// src/components/common/PartnerCard.jsx
import React from "react";

export default function PartnerCard({
  title,
  description,
  icon,          
  className = "",
  iconAlt = "",
}) {
  return (
    <div
      className={`
        relative group rounded-[16px] p-[1px]
        bg-gradient-to-t from-[#036AE5]/80 to-white
        transition-all duration-500
        ${className}
      `}
    >
      <div
        className="
          relative rounded-[16px] bg-white/80 min-h-[150px] tabletair:min-h-[200px] tabletmini:min-h-[220px]
          content-center
        "
      >

        <div className="flex justify-start items-center gap-4 tabletair:gap-3 tabletmini:gap-3 p-4">
          {icon && (
            <img
              src={icon}
              alt={iconAlt}
              className="
                w-[100px] h-[96px] tabletpro:w-[52px] tabletpro:h-[52px]
                tabletair:w-[52px] tabletair:h-[52px]
                tabletmini:w-[44px] tabletmini:h-[44px]
                mobile:w-[44px] mobile:h-[44px]
                object-contain select-none
              "
              draggable="false"
            />
          )}

          <div className="">
            <h3
              className="
                text-[#0B1225] font-semibold
                text-[20px] mobile:text-[16px]
                tabletpro:text-[18px] tabletair:text-[18px] tabletmini:text-[18px]
              "
            >
              {title}
            </h3>

            {description && (
              <p
                className="
                  mt-1 text-[#3A505F] font-normal
                  text-[16px] mobile:text-[14px]
                  tabletpro:text-[16px] tabletair:text-[16px] tabletmini:text-[16px]
                "
              >
                {description}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
